import React, { Fragment, useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import CoureseTab from "./Tabs/CoureseTab";
import Sidebar from "./sidebar";
import { useGetCourseDetailByIdQuery } from "../../api/courseApi";
import IsLoading from "../../components/Loading/IsLoading";
import { useGiftCourseMutation, useThisCourseEnrolledUserMutation } from "../../api/studentCourseApi";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import CourseSingleAccardion from "./CourseSingleAccardion";
import InstructorDetails from "./InstructorDetails";
import Review from "./Tabs/Review";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { toast } from "react-toastify";
import CartDropdown from "../../components/header/Cart/CartDropdown";
import './Styles/CourseSinglePage.css';
const CourseSinglePage = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const { data, isLoading } = useGetCourseDetailByIdQuery(slug);
  const [CheckHasThisCourse] = useThisCourseEnrolledUserMutation();
  const [giftCourse] = useGiftCourseMutation();
  const [ownMyCourse, setOwnMyCourse] = useState(false);
  const [isEnrolledCourse, setIsEnrolledCourse] = useState(false);
  const [course, setCourse] = useState();
  const [cart, setCart] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [videoOpen, setVideoOpen] = useState(false);
  const [showCartDropdown, setShowCartDropdown] = useState(false);
  const authenticationState = useSelector(
    (state) => state.authStore
  );
  const courseData = data?.result?.item1;
  const reviews = [
    {
      name: "Ahmet Yılmaz",
      rating: 5,
      comment: "Harika bir kurs! Anlatım çok net ve konular çok iyi organize edilmiş. Eğitmen gerçekten işinin ehli."
    },
    {
      name: "Zeynep Kaya",
      rating: 5,
      comment: "Bu kursu aldığım için çok mutluyum. Kariyer gelişimime büyük katkı sağladı. Kesinlikle tavsiye ediyorum!"
    },
    {
      name: "Mehmet Demir",
      rating: 4,
      comment: "Pratik örneklerle desteklenmiş, çok verimli bir eğitim. Her seviyeye uygun içerik bulunuyor."
    },
    {
      name: "Ayşe Şahin",
      rating: 5,
      comment: "Eğitmenin anlatım tarzı ve örnekleri çok başarılı. Sıfırdan başlayanlar için ideal bir kurs."
    },
    {
      name: "Mustafa Özkan",
      rating: 5,
      comment: "Konular çok detaylı işlenmiş. Özellikle proje odaklı yaklaşım çok faydalı oldu."
    },
    {
      name: "Elif Yıldız",
      rating: 4,
      comment: "Sektörde ihtiyaç duyulan tüm konular ele alınmış. Güncel ve kapsamlı bir eğitim."
    },
    {
      name: "Can Aydın",
      rating: 5,
      comment: "Eğitmenin tecrübesi ve bilgi birikimi derslere çok iyi yansımış. Sorularımıza hızlı dönüş aldık."
    },
    {
      name: "Selin Arslan",
      rating: 5,
      comment: "Kurs materyalleri ve ödevler çok öğretici. Pratik yapma imkanı oldukça fazla."
    },
    {
      name: "Burak Çelik",
      rating: 4,
      comment: "Modern teknolojiler ve güncel yaklaşımlar çok iyi anlatılmış. Kendimi geliştirmeme çok yardımcı oldu."
    },
    {
      name: "Deniz Koç",
      rating: 5,
      comment: "Teorik bilgiler pratik uygulamalarla pekiştirilmiş. Çok verimli bir eğitim süreci geçirdim."
    },
    {
      name: "Gözde Akın",
      rating: 5,
      comment: "İş hayatımda kullanabileceğim çok değerli bilgiler edindim. Eğitmen sürekli destek sağladı."
    },
    {
      name: "Onur Yılmaz",
      rating: 5,
      comment: "Kurs içeriği çok zengin ve güncel. Gerçek projelerle öğrenme fırsatı bulduk."
    }
  ];
  console.log("trigger authentication state",authenticationState)
  useEffect(() => {
    if (data) {
      setCourse(data.result.item1);
    }

    async function CheckActiveCourse() {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decode = jwtDecode(token);
          const model = {
            userId: decode.nameid,
            courseId: data?.result?.item1?.courseId,
          };

          await CheckHasThisCourse(model).then((response) => {
            setIsEnrolledCourse(response.data);
          });
        } catch (error) {
          console.error("Error decoding token:", error);
          setIsEnrolledCourse(false);
        }
      } else {
        // Handle guest user
        setIsEnrolledCourse(false);
      }
    }
    CheckActiveCourse();
  }, [isLoading]);

  if (isLoading || !course) {
    return <IsLoading />;
  }

  const triggerButton = () => {
    console.log("trigge",course.courseId)
    navigate(`/lessons/${course.courseId}`);
  };
  const giftCourseThisUser = async () => {
    console.log("triggergiftCourseThisUser",authenticationState);
    const courseModel = {
      email: authenticationState.email,
      courseId: slug
    };
  
    var result = await giftCourse(courseModel).then((response) => {
      if (response.error && response.error.status === 401) {
        navigate("/login", { state: { from: window.location.pathname } });

        toast.warning("Please login first");
        return;
      }
  
      if (response.data.isSuccess) {
        toast.success(response.data.message);
  
        setTimeout(() => {
          navigate(0); 
        }, 1000);
      } else {
        toast.warning(response.data.message);
      }
    });
  };
  
  const carouselStyles = {
    carousel: {
      position: 'relative',
      perspective: '1000px',
      transformStyle: 'preserve-3d',
      overflow: 'hidden',
      padding: '20px 0',
    },
    track: {
      display: 'flex',
      transition: 'transform 0.5s ease-in-out',
      gap: '20px',
    },
    card: {
      flex: '0 0 100%',
      transition: 'all 0.5s ease-in-out',
    },
    activeCard: {
      opacity: 1,
      transform: 'scale(1)',
      filter: 'blur(0)',
    },
    inactiveCard: {
      opacity: 0.5,
      transform: 'scale(0.95)',
      filter: 'blur(2px)',
    },
    navButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      cursor: 'pointer',
      zIndex: 10,
      transition: 'all 0.3s ease',
    },
  };

  return (
    <Fragment>
      <Navbar />
      <div className="course-detail-shell container mx-auto flex flex-col sm:gap-6 gap-4 sm:px-8 lg:px-16 xl:px-20 mb-12">
        <div className="course-breadcrumb-card">
          <Breadcrumbs
            steps={[
              {
                title: courseData?.courseName,
                to: `/course-single/${slug}`,
              },
            ]}
          />
        </div>
        
        <div className="flex flex-col lg:flex-row gap-8 mt-2">
          {/* Video ve Kurs Bilgileri */}
          <div className="lg:w-8/12 flex flex-col gap-6">
            {/* Video Bölümü - Kitap Kapağı Efekti */}
            <div className="course-video-wrapper">
              <div className="video-book-container">
                <div 
                  className={`video-book-cover ${videoOpen ? 'opening' : ''}`}
                  onClick={() => setVideoOpen(true)}
                >
                  <div className="video-book-cover-content">
                    <div className="play-icon-wrapper">
                      <svg fill="currentColor" viewBox="0 0 16 16">
                        <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                      </svg>
                    </div>
                    <h3 className="video-title">{courseData?.courseName}</h3>
                    <p className="video-subtitle">Videoyu izlemek için tıklayın</p>
                  </div>
                </div>
                
                <div className="video-content">
                  {courseData?.introductionVideoUrl ? (
                    <video
                      src={courseData?.introductionVideoUrl}
                      controls
                      autoPlay={videoOpen}
                      poster={courseData?.coverImageUrl || ""}
                      preload="metadata"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                      <p className="text-gray-500">Video mevcut değil</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            
            {/* Kurs içeriği */}
            <div className="course-content-card">
              <h1 className="course-section-title">{courseData?.courseName}</h1>
              
              <div className="mb-6 flex flex-wrap gap-3">
                <span className="course-badge">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.5 9.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"/>
                  </svg>
                  {courseData?.categoryName || "Kategori"}
                </span>
                {courseData?.level && (
                  <span className="course-badge">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5Z"/>
                    </svg>
                    {courseData?.level} Seviye
                  </span>
                )}
                {courseData?.totalDuration && (
                  <span className="course-badge">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
                    </svg>
                    {courseData?.totalDuration}
                  </span>
                )}
              </div>
              
              <p className="text-gray-700 text-lg mb-6 leading-relaxed">
                {courseData?.courseDescription}
              </p>
              
              {isEnrolledCourse ? (
                <div className="flex justify-end">
                  <button 
                    className="course-action-btn secondary" 
                    onClick={triggerButton}
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>
                    </svg>
                    Derse Başla
                  </button>
                </div>
              ) : courseData?.coursePrice === 0 ? (
                <div className="flex justify-end">
                  <button 
                    className="course-action-btn success" 
                    onClick={giftCourseThisUser}
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5Z"/>
                    </svg>
                    Ücretsiz Kayıt Ol
                  </button>
                </div>
              ) : (
                <div className="w-full">
                  <Sidebar courseDetail={courseData} onCartAdd={() => setShowCartDropdown(true)}></Sidebar>
                </div>
              )}
            </div>
            
            {/* Kurs Müfredatı */}
            <div className="course-content-card">
              <h2 className="course-section-title">Kurs Müfredatı</h2>
              <CourseSingleAccardion courseDetail={course} />
            </div>
          </div>
          
          {/* Yan Bölüm - Eğitmen Bilgileri */}
          <div className="lg:w-4/12">
            <div className="sticky top-24">
              <InstructorDetails instructor={data?.result?.item1?.user} />
              
              {/* Kurs Detayları */}
              <div className="course-content-card mt-6">
                <h2 className="course-section-title" style={{fontSize: '1.5rem'}}>Kurs Detayları</h2>
                <ul className="course-details-list">
                  <li>
                    <i className="fas fa-users"></i>
                    <div>
                      <span className="font-semibold block text-gray-800">350 Öğrenci</span>
                      <span className="text-sm text-gray-500">Bu kursa kayıtlı</span>
                    </div>
                  </li>
                  <li>
                    <i className="fas fa-file-video"></i>
                    <div>
                      <span className="font-semibold block text-gray-800">{course?.sections?.reduce((total, section) => total + section.videos?.length, 0) || '0'} Video</span>
                      <span className="text-sm text-gray-500">Detaylı anlatım</span>
                    </div>
                  </li>
                  <li>
                    <i className="fas fa-certificate"></i>
                    <div>
                      <span className="font-semibold block text-gray-800">Sertifika</span>
                      <span className="text-sm text-gray-500">Tamamlama belgesi</span>
                    </div>
                  </li>
                  <li>
                    <i className="fas fa-infinity"></i>
                    <div>
                      <span className="font-semibold block text-gray-800">Ömür Boyu Erişim</span>
                      <span className="text-sm text-gray-500">İstediğin zaman tekrar et</span>
                    </div>
                  </li>
                  <li>
                    <i className="fas fa-mobile-alt"></i>
                    <div>
                      <span className="font-semibold block text-gray-800">Mobil Erişim</span>
                      <span className="text-sm text-gray-500">Her cihazdan izle</span>
                    </div>
                  </li>
                </ul>
              </div>
              
              {/* Öğrenci Yorumları Carousel */}
              <div className="course-content-card mt-6">
                <h2 className="course-section-title" style={{fontSize: '1.5rem'}}>Öğrenci Yorumları</h2>
                <div className="relative">
                  <div className="review-carousel overflow-hidden">
                    <div className="carousel-track flex transition-transform duration-300" style={{transform: `translateX(${currentSlide * -100}%)`}}>
                      {reviews.map((review, index) => (
                        <div 
                          key={index}
                          className="review-card min-w-full transition-all duration-300"
                        >
                          <div className="course-review-panel">
                            <div className="flex items-center mb-4">
                              <div className="course-review-avatar">
                                {review.name.charAt(0)}
                              </div>
                              <div className="ml-4">
                                <h3 className="font-semibold text-lg text-gray-800">{review.name}</h3>
                                <div className="course-review-stars">
                                  {[...Array(5)].map((_, i) => (
                                    <svg key={i} className={`w-4 h-4 ${i < review.rating ? 'filled' : ''}`} fill="currentColor" viewBox="0 0 20 20">
                                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                                    </svg>
                                  ))}
                                </div>
                              </div>
                            </div>
                            <p className="text-gray-600 italic leading-relaxed">{review.comment}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <button 
                    onClick={() => setCurrentSlide(prev => (prev - 1 + reviews.length) % reviews.length)}
                    className="course-review-nav left-0"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </button>
                  <button 
                    onClick={() => setCurrentSlide(prev => (prev + 1) % reviews.length)}
                    className="course-review-nav right-0"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/>
                    </svg>
                  </button>
                  <div className="flex justify-center mt-4 gap-2">
                    {reviews.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentSlide(index)}
                        className={`course-review-dot ${currentSlide === index ? 'active' : ''}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Scrollbar />
      <CartDropdown
        show={showCartDropdown}
        onClose={() => setShowCartDropdown(false)}
      />
    </Fragment>
  );
};

export default CourseSinglePage;